<router-outlet></router-outlet>
<ngx-spinner type="ball-spin-clockwise">
    <p>Please wait.</p>
</ngx-spinner>
<!-- <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please wait.</p>
</ngx-spinner> -->